import { useMemo } from 'react';

import { useKioskAdSetsQuery, KioskAdSetFragment, Kiosk_Ad_Set_Status } from '@occc/graphql';

/**
 * Maximum number of ad sets to fetch per query.
 * This limit is set to handle typical use cases where kiosks have fewer than 500 published ad sets.
 * If more ad sets are needed, consider implementing cursor-based pagination.
 */
const AD_SETS_FETCH_LIMIT = 100;

type UseGetScheduleAdSetsProps = {
  kioskIds: string[];
};

export const useGetScheduleAdSets = ({ kioskIds }: UseGetScheduleAdSetsProps) => {
  const { data, loading, error } = useKioskAdSetsQuery({
    variables: {
      first: AD_SETS_FETCH_LIMIT,
      filter: {
        kioskIdIncludes: kioskIds,
        status: Kiosk_Ad_Set_Status.Published,
      },
    },
    skip: kioskIds.length === 0,
    fetchPolicy: 'cache-and-network',
  });

  const adSets = useMemo(() => {
    return data?.kioskAdSets.edges.map((edge) => edge.node as KioskAdSetFragment) || [];
  }, [data]);

  return {
    data: adSets,
    loading,
    error,
  };
};
